var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9667 3.89884L12.7391 3.12644C14.0189 1.84669 16.0938 1.84669 17.3735 3.12644C18.6533 4.40619 18.6533 6.48109 17.3735 7.76084L16.6011 8.53324M11.9667 3.89884C11.9667 3.89884 12.0633 5.54019 13.5115 6.98844C14.9598 8.43669 16.6011 8.53324 16.6011 8.53324M11.9667 3.89884L4.86571 10.9999C4.38474 11.4808 4.14425 11.7213 3.93744 11.9865C3.69347 12.2993 3.4843 12.6377 3.31364 12.9958C3.16896 13.2994 3.06142 13.622 2.84632 14.2673L1.93486 17.0017M16.6011 8.53324L9.5001 15.6343C9.01914 16.1152 8.77865 16.3557 8.51349 16.5625C8.2007 16.8065 7.86226 17.0157 7.50417 17.1863C7.2006 17.331 6.87796 17.4386 6.23267 17.6537L3.49829 18.5651M3.49829 18.5651L2.82989 18.7879C2.51234 18.8938 2.16224 18.8111 1.92555 18.5744C1.68886 18.3377 1.60621 17.9876 1.71206 17.6701L1.93486 17.0017M3.49829 18.5651L1.93486 17.0017",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIco);
export default __webpack_public_path__ + "static/media/edit-ico.70e80d21de96c954ba22089541b5573c.svg";
export { ForwardRef as ReactComponent };